import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { ApprovalTaskItemApiService } from '../index';
import { DeactivateApprovalTaskItemMutation, IApprovalTaskItem, IApprovalTaskItemInput } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import { GetApprovalTaskItemByIdQuery, SaveApprovalTaskItemMutation, DeleteApprovalTaskItemMutation } from '@ebb-v2/ebb-integration';

@Injectable({
    providedIn: 'root'
  })
export class ApprovalTaskItemGqlService implements ApprovalTaskItemApiService {
  
  constructor(
    private apollo: Apollo
  ) { }

  public getItem(id: string): Observable<IApprovalTaskItem> {
    //console.log(`ApprovalTaskItemGql.getItem()`);
    return this.apollo
      .watchQuery({
        query: GetApprovalTaskItemByIdQuery,
        variables: {
          id: id,
        } 
      })
      .valueChanges
      .pipe(map(result => result.data['approvalTaskItem'] as IApprovalTaskItem), take(1));    
  }

  public saveItem(approvalTaskItem: IApprovalTaskItemInput, applicationId: String, approvalTaskId: String | null): Observable<any> {
    return this.apollo
      .mutate({
        mutation: SaveApprovalTaskItemMutation,
        variables : {
          approvalTaskItem,
          applicationId,
          approvalTaskId
        }
      })
      .pipe(map(result => result.data['saveApprovalTaskItem'] as IApprovalTaskItem));
  }

  public deleteItem(approvalTaskItemId: String,applicationId:String): Observable<any> {
    return this.apollo
    .mutate({
      mutation: DeleteApprovalTaskItemMutation,
      variables : {
        approvalTaskItemId: approvalTaskItemId,
        applicationId:applicationId
      }
    })
    .pipe(map(result => result.data['deleteApprovalTaskItem'] as any));
  }
  public deactivateItem(approvalTaskItemId: String,applicationId:String): Observable<any> {
    return this.apollo
    .mutate({
      mutation: DeactivateApprovalTaskItemMutation,
      variables : {
        approvalTaskItemId: approvalTaskItemId,
        applicationId:applicationId
      }
    })
    .pipe(map(result => result.data['deactivateApprovalTaskItem'] as any));
  }
}

